<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-11 17:36:26
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-12 19:30:32
 * @FilePath: \hzs-nutra-wecom-shop\src\views\activity\activity.vue
 * @Description: 门店活动
-->

<template>
    <div class="activity-container">
        <!-- 直播列表 -->
        <!-- 下拉刷新 + 上拉加载 -->
        <div class="list-container">
            <van-pull-refresh
                v-if="state.liveList.length > 0"
                class="scroll-view"
                v-model="state.refreshing"
                @refresh="onRefresh"
            >
                <van-list
                    v-model:loading="state.loading"
                    :finished="state.finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    v-model:error="state.error"
                    error-text="请求失败，点击重新加载"
                    :offset="100"
                >
                    <!-- 数据列表 -->
                    <div class="activity-list">
                        <div
                            v-for="(activity, index) in state.liveList"
                            :key="index"
                            class="activity-item"
                            @click="goto(activity)"
                        >
                            <div class="up flex justify-sc align-start">
                                <div class="activity-info">
                                    <div class="activity-title">
                                        {{ activity.title }}
                                    </div>
                                    <div class="activity-time">
                                        活动时间: {{ activity.startTime }} -
                                        {{ activity.endTime }}
                                    </div>
                                </div>
                                <div
                                    :class="[
                                        'activity-status',
                                        activity.className,
                                    ]"
                                >
                                    {{ activity.statusText }}
                                </div>
                            </div>
                            <div class="down flex justify-se">
                                <van-button
                                    color="#DCBB89"
                                    v-if="activity.signStatus === 0"
                                    @click.stop="
                                        OperationActivity(
                                            'sign',
                                            activity,
                                            index
                                        )
                                    "
                                    >去签到</van-button
                                >
                                <van-button
                                    color="#999999"
                                    v-if="activity.signStatus === 1"
                                    @click.stop="
                                        OperationActivity(
                                            'endSign',
                                            activity,
                                            index
                                        )
                                    "
                                    >已签到</van-button
                                >
                            </div>
                        </div>
                    </div>

                    <!-- 自定义加载提示 -->
                    <template #loading>
                        <div class="loading-wrapper">
                            <van-loading type="spinner" size="20px" />
                            <span>加载中...</span>
                        </div>
                    </template>
                </van-list>
            </van-pull-refresh>

            <!-- 空状态 -->
            <van-empty
                class="empty-wrapper"
                v-if="state.liveList.length === 0 && !state.loading"
                description="暂无数据"
            />
        </div>
        <!-- 底部导出按钮（自定义组件 footer） -->
        <div class="bottom_button_box">
            <button class="scan-button" @click="gotoActivity">
                查看门店活动
            </button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, h, onMounted, watch } from "vue";
import dayjs from "dayjs";
import api from "@/utils/api/activity.js";

import { setStatusStyle, onClickLeft } from "@/utils/common.js";
import {
    showToast,
    showLoadingToast,
    showSuccessToast,
    showFailToast,
    showDialog,
} from "vant";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
// 状态列表
const statusList = [
    { id: 20, name: "进行中" },
    { id: 1, name: "待开始" },
    { id: 30, name: "已结束" },
    { id: 40, name: "已取消" },
    { id: 0, name: "全部" },
];

// 当前选中的状态
const currentStatus = ref(20);

const state = reactive({
    userInfo: JSON.parse(localStorage.getItem("userInfo")), // 用户信息
    weComUserInfo: JSON.parse(localStorage.getItem("weComUserInfo")), // 企业微信用户信息
    departmentdata: JSON.parse(localStorage.getItem("departmentdata")), // 部门数据
    loading: false, // 列表数据是否正在加载
    refreshing: false, // 列表数据是否正在刷新
    finished: false, // 列表数据是否加载完毕
    error: false, // 列表数据是否加载失败

    queryParams: {}, // 查询参数
    // 直播列表数据
    liveList: [],
    hasMore: true, // 是否还有更多数据
    pagination: {
        total: 0,
        page: 1,
        page_size: 10,
    },
});

// --------------------------------------- 方法、事件
// 解析 query 参数
const queryParams = computed(() => {
    // 如果 resultStr 是字符串，需要解析
    if (route.query.resultStr) {
        return parseQueryString(route.query.resultStr);
    }
    return {};
});

// 解析 URL 参数字符串为对象
const parseQueryString = (str) => {
    const params = {};
    const pairs = str.split("&");

    for (const pair of pairs) {
        const [key, value] = pair.split("=");
        if (key) {
            params[key] = decodeURIComponent(value || "");
        }
    }
    return params;
};
onMounted((val) => {
    state.queryParams = queryParams.value;
    // 调用获取活动列表接口
    getActivityData();
});
// 跳转发布活动页面
const goto = (row) => {
    // router.push({
    //     path: "/activityAdd",
    //     query: {
    //         // id: row.id,
    //     },
    // });
};
// 跳转至门店活动列表页
const gotoActivity = () => {
    router.push({
        path: "/activity",
    });
};
// 上拉加载更多
const onLoad = async () => {
    try {
        getActivityData();
    } catch (error) {
        showFailToast("加载失败");
    }
};

// 下拉刷新
const onRefresh = async () => {
    state.finished = false;
    state.pagination.page = 1;
    try {
        getActivityData();
        // showSuccessToast("刷新成功");
    } catch (error) {
        // showFailToast("刷新失败");
    } finally {
        state.refreshing = false;
    }
};
// 监听 currentStatus 变化，更新 v-model
watch(
    currentStatus,
    (newValue) => {
        state.pagination.page = 1;
        // 调用获取活动列表接口
        getActivityData();
    },
    { deep: true }
);
// 操作活动
const OperationActivity = async (type, activity, index) => {
    let text = "";
    let apiName = "";
    switch (type) {
        case "sign":
            text = "签到";
            apiName = "signActivity";
            break;
        case "endSign":
            text = "立即结束";
            break;
    }
    if (type === "endSign") {
        showFailToast(`活动已签到！`);
        return;
    }
    showDialog({
        title: "提示",
        message: `确定要${text}该活动吗？`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
    }).then(
        async () => {
            // onConfirm
            // router.push({
            //     path: "/checkinstatus",
            //     query: { msg: "签到失败，请重试？" },
            // });
            let res = await api[apiName]({
                uuid: activity.uuid,
                user_uuid: state.queryParams.user_uuid,
            });

            if (res.code !== 200) {
                showFailToast(`${text}失败`);
                router.push({
                    path: "/checkinstatus",
                    query: { msg: res.msg || "签到失败！请重试" },
                });
                return;
            }
            router.push({
                path: "/checkinstatus",
                query: { msg: "" },
            });
            showSuccessToast(`${text}成功`);
            state.liveList[index].signStatus = 1;
        },
        () => {
            // onCancel
            // showFailToast(`${text}取消`);
        }
    );
    // 调用接口
};

// --------------------------------------- 请求
// 获取活动列表
async function getActivityData() {
    const toast = showLoadingToast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
    });
    try {
        const res = await api.getActivityList({
            shop_uuid: state.queryParams.shop_uuid,
            status: currentStatus.value,
            page: state.pagination.page,
            page_size: state.pagination.page_size,
        });
        let time = setTimeout(() => {
            clearTimeout(time);
            toast.close();
        }, 2000);
        if (res.code !== 200) {
            state.error = true;
            return;
        }
        let list =
            res.data?.map((item) => ({
                ...item,
                start_time: dayjs(item.start_time).format(
                    "YYYY-MM-DD HH:mm:ss"
                ),
                end_time: dayjs(item.end_time).format("YYYY-MM-DD HH:mm:ss"),
                startTime: dayjs(item.start_time).format("MM/DD HH:mm"),
                endTime: dayjs(item.end_time).format("MM/DD HH:mm"),
                startTime_s: dayjs(item.start_time).format("YYYY-MM-DD"),
                endTime_s: dayjs(item.end_time).format("YYYY-MM-DD"),
                className: setStatusStyle(item.status).className,
                statusText: setStatusStyle(item.status).statusText,
                isLive: item.status == 20, // 判断是否正在进行中
                signStatus: item?.sign_status || 0, // 签到状态
            })) || [];
        state.liveList =
            state.pagination.page === 1 ? list : state.liveList.concat(list);
        state.pagination.total = res.cnt || 0; // 总条数
        state.finished = state.liveList.length >= state.pagination.total;
        if (!state.finished) {
            state.pagination.page += 1;
        }
    } catch (error) {
        state.error = true;
    } finally {
        toast.close();
        state.loading = false; // 关键：无论成功失败，都要关闭 loading
    }
}
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
.activity-container {
    padding-bottom: 70px;
}

/* 状态导航样式 */
.status-nav {
    position: sticky;
    top: 0;
    left: 0;
    display: flex;
    background-color: #fff;
    padding: 15px 0;
    overflow-x: auto;
    white-space: nowrap;
    border-bottom: 1px solid #f6f6f6;
    width: 100%;
    height: 55px;
    z-index: 999;
    box-sizing: border-box;

    &::-webkit-scrollbar {
        display: none;
    }
}

.status-item {
    padding: 0 15px;
    font-size: 15px;
    color: #999999;
    cursor: pointer;
    position: relative;

    &.active {
        color: #dcbb89;
        font-weight: 500;
    }

    &.active::after {
        content: "";
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 2px;
        background-color: #dcbb89;
    }
}

/* 直播列表样式 */
.list-container {
}
.scroll-view {
}
.activity-list {
    padding: 10px 17px;
}

.activity-item {
    background-color: #fff;
    padding: 15px 13px;
    margin-bottom: 10px;
    border-radius: 8px;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
}

.activity-info {
    flex: 1;
}

.activity-title {
    font-size: 17px;
    font-weight: 500;
    color: #333;
    margin-bottom: 5px;
    font-family: "PingFang SC-Medium";
}

.activity-time {
    font-size: 13px;
    color: #666;
}

.activity-status {
    font-size: 14px;
    // color: #ff7123;
    font-weight: 500;
}

.down {
    .van-button {
        height: 38px;
    }
    gap: 10px;
}
// 发布按钮
.publish-btn {
    position: fixed;
    bottom: 50px;
    right: 20px;
    width: 60px;
    height: 60px;
    background-color: #dcbb89;
    border-radius: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
}
.create_icon {
    width: 24px;
    height: 24px;
}
.activity-container {
    .bottom_button_box {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #ffffff;
        padding: 10px;
        display: flex;
        justify-content: flex-end;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
        z-index: 100;
        max-width: 450px;
        margin: 0 auto;
        .scan-button {
            width: 100%;
            background-color: #fff;
            color: #dcbb89;
            border: 2px solid #dcbb89;
            border-radius: 11px;
            font-size: 19px;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s;

            &:active {
                background-color: #c8a77c;
            }
        }
    }
}
</style>
